import { defineStore } from 'pinia'

import type { DisciplineFilesStore } from './interfaces'

import { emptyDisciplineFilesFilters } from '../../../lib/discipline-files-query'
import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineFilesStore = defineStore('discipline-files', {
  state: (): DisciplineFilesStore => ({
    loading: false,
    packs: [],
    tasks: [],
    meta: null,
    filters: emptyDisciplineFilesFilters(),
    currentPage: 1,
    perPage: 25,
    activeModal: null,
    activePackId: null,
  }),
  actions,
  getters,
})
